module.exports = __webpack_public_path__ + "img/food_item_3.c15a696b.png";